import { useState } from "react";

export type MouseStateController = {
  enabled: boolean;
};

export function useMouseStateController({ enabled }: MouseStateController) {
  const [isHovered, setIsHovered] = useState(false);

  function onMouseEnter() {
    setIsHovered(true);
  }

  function onMouseLeave() {
    setIsHovered(false);
  }

  return {
    onMouseEnter: enabled ? onMouseEnter : undefined,
    onMouseLeave: enabled ? onMouseLeave : undefined,
    isHovered: isHovered,
  };
}
